import React from 'react';
import * as enums from '@local/finsera-core/src/enums';
import { useSelector } from '@local/finsera-core/src/libs';
import { mui } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import ResourceAutocomplete from '../../../resource-autocomplete';
import Bounds from '../bounds';
import SharedConstraintFields from '../shared-fields';

type TradeListSignalExposureConstraintProps = {
  id: string;
  params: types.optimizer.TradeListSignalExposureConstraintDraft;
  setParams: (_params: types.optimizer.TradeListSignalExposureConstraintDraft) => void;
  readOnly: boolean;
  validationDef: types.common.ValidationErrors;
};

const TradeListSignalExposureConstraint = ({
  id,
  params,
  setParams,
  readOnly,
  validationDef,
}: TradeListSignalExposureConstraintProps) => {
  const [showMore, setShowMore] = React.useState(false);

  const signals = useSelector((state) => state.resources.signals);

  return (
    <>
      <mui.core.Box p={3}>
        <mui.core.Box pb={3}>
          <mui.core.TextField
            select
            label="Constraint Type"
            variant="outlined"
            value={params.trade_list_constraint_type}
            onChange={(e) =>
              setParams({
                ...params,
                trade_list_constraint_type: e.target
                  .value as types.optimizer.TradeListConstraint['trade_list_constraint_type'],
              })
            }
            fullWidth
            disabled={readOnly}
            size="small"
            error={validationDef?.fields?.includes(`constraint_type_${id}`)}
          >
            <mui.core.MenuItem value={'DONT_TRADE'}>{"Don't Trade"}</mui.core.MenuItem>
            <mui.core.MenuItem value={'NO_INCREASE'}>{'No Increase'}</mui.core.MenuItem>
            <mui.core.MenuItem value={'DONT_BUY'}>{"Don't Buy"}</mui.core.MenuItem>
            <mui.core.MenuItem value={'DONT_SELL'}>{"Don't Sell"}</mui.core.MenuItem>
            <mui.core.MenuItem value={'DONT_SHORT'}>{"Don't Short"}</mui.core.MenuItem>
            <mui.core.MenuItem value={'DONT_COVER'}>{"Don't Cover"}</mui.core.MenuItem>
            <mui.core.MenuItem value={'NO_HOLD'}>{'No Hold'}</mui.core.MenuItem>
          </mui.core.TextField>
        </mui.core.Box>

        <mui.core.Box pb={3}>
          <ResourceAutocomplete<types.signal.SignalExpanded>
            value={params.signal_id}
            setValue={(id) =>
              setParams({
                ...params,
                signal_id: id,
                signal_handle: signals.find((s) => s.id == id).handle,
              })
            }
            type={enums.RESOURCES_TYPES_ENUM.SIGNAL}
            disabled={readOnly}
            inputProps={{
              fullWidth: true,
              label: 'Signal',
              variant: 'outlined',
              size: 'small',
              required: true,
              error: validationDef?.fields?.includes(`signal_${id}`),
            }}
          />
        </mui.core.Box>

        <mui.core.Box pb={3}>
          <Bounds id={id} params={params} setParams={setParams} readOnly={readOnly} validationDef={validationDef} />
        </mui.core.Box>

        {showMore && (
          <SharedConstraintFields
            id={id}
            params={params}
            setParams={setParams}
            showRelaxation={false}
            readOnly={readOnly}
            validationDef={validationDef}
          />
        )}
      </mui.core.Box>
      <mui.core.Box pt={0} p={3}>
        <mui.core.Button
          onClick={() => {
            setShowMore(!showMore);
          }}
          color="primary"
          sx={{ mx: 2, mb: 2 }}
          startIcon={showMore ? <mui.icons.Remove /> : <mui.icons.Add />}
        >
          {showMore ? <>Show Less</> : <>Show More</>}
        </mui.core.Button>
      </mui.core.Box>
    </>
  );
};

export default TradeListSignalExposureConstraint;
